import { createSelector } from 'reselect';
import { subselect } from './root';
import { propertiesSelector } from './properties';
import { USER_ACCOUNT_STATE_STATUSES } from '../constants';

const isUnauthenticatedSelector = createSelector(
  [propertiesSelector],
  ({ status }) => status === USER_ACCOUNT_STATE_STATUSES.NOT_AUTHENTICATED,
);

export const userAccountIsUnauthenticatedSelector = subselect(isUnauthenticatedSelector);
